// extracted by mini-css-extract-plugin
export default {"filterComponent":"DocumentSettingsContainer_filterComponent__RnifR"};